import { getDate2 } from './tools'

export const pendingDocuments = {
  '/h5mgt/po_stkchk': { table: 'V_IC_STK_QA', date: 'ICDTTM', condition: " and IDTY='QACHK' and STFG='N'" },
  '/mobile/po_cfm': { table: 'V_PO_SENT_MIN', date: 'ADDDTTM', condition: " and STFG='N'" },
  '/mobile/po_barcode': { table: 'V_PO_REQ_LOCK', condition: " and STFG='Y' and ISCHK='N'" },
  '/mobile/stk_barin': { table: 'V_IC_STK_H5_POIN', date: 'ADDDTTM', condition: " and STFG='N'" },
  '/mobile/mat_out': { table: 'V_IC_STK_PRDOUT', date: 'ADDDTTM', condition: " and STFG='N'" }
}
export const menuPath = url => String(url || '').split(/[?#]/)[0]
const literal = value => "'" + String(value || '').replace(/'/g, "''") + "'"
export function recentDocumentCondition(path, corpid) {
  const config = pendingDocuments[menuPath(path)]
  if (!config || !corpid) throw new Error('缺少账套或单据配置')
  return ' and CORPID=' + literal(corpid) + (config.date ? ' and ' + config.date + '>=' + literal(getDate2(config.days || 30)) : '')
}
export function pendingCondition(path, corpid) {
  return recentDocumentCondition(path, corpid) + pendingDocuments[menuPath(path)].condition
}
export function parsePendingCount(response) {
  if (!response || String(response.code) !== '200') throw new Error('数量获取失败')
  const raw = response.result
  // 只接受明确的非负整数，不能把空响应或未知结构转换为零。
  const value = typeof raw === 'number' || typeof raw === 'string' ? raw : undefined
  if (value === undefined || !/^\d+$/.test(String(value))) throw new Error('计数返回格式异常')
  const count = Number(value)
  if (!Number.isSafeInteger(count)) throw new Error('计数超出范围')
  return count
}

// 聚合放在数据库完成，避免下载明细；内层 DISTINCT 保证一张单据只计一次。
export function pendingCountRequest(path, corpid) {
  const config = pendingDocuments[menuPath(path)]
  const condition = pendingCondition(path, corpid)
  return { p_table: '(select distinct IDSEQ from ' + config.table + ' where 1=1' + condition + ') PENDING_DOCS', p_cond: '' }
}

export function uniqueDocuments(rows) {
  const seen = new Set()
  return rows.filter(row => {
    const id = String(row.IDSEQ)
    if (seen.has(id)) return false
    seen.add(id)
    return true
  })
}
